import { reactive, ref } from 'vue';

const model = reactive({
	code: null,
	taxNumber: null,
	name: null,
	contactPerson: null,
	email: null,
	phoneNumber: null,
	invoiceFormat: null,
	privacyPolicyAccepted: null,
	dataChangeAccepted: null,
	captchaKey: null,
	captchaText: null
});

const captchaError = ref(false);

export const useStore = () => {
	return { model, captchaError };
};
